/** MCP tool names may be namespaced by the server key, e.g.
 * `yepairag_composio__CREATE_CONTENT_DRAFT`. Keep the raw name for protocol
 * messages, but use the canonical/display name for UI and tool matching.
 */
export function canonicalWsToolName(name: string): string {
  const trimmed = name.trim();
  const separator = trimmed.lastIndexOf('__');
  if (separator < 0) return trimmed;
  const canonical = trimmed.slice(separator + 2).trim();
  return canonical || trimmed;
}

export function displayWsToolName(name: string): string {
  return canonicalWsToolName(name);
}
